import { render, staticRenderFns } from "./FarmSettings.vue?vue&type=template&id=2ac4893e&scoped=true"
import script from "./FarmSettings.vue?vue&type=script&lang=js"
export * from "./FarmSettings.vue?vue&type=script&lang=js"
import style0 from "./FarmSettings.vue?vue&type=style&index=0&id=2ac4893e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac4893e",
  null
  
)

export default component.exports